import React from 'react'
import { RoleConstants } from '../../../constants'

const BalanceAfterPurchase = ({ user, client, paymentCondition, role }) => {
	var notAuthenticated = user === null
	if (notAuthenticated || RoleConstants.Client !== role) return null

	const balance = client.balancePoints - paymentCondition.points
	let text =
		balance < 0
			? 'Você ainda não possui saldo suficiente para comprar o produto'
			: `Saldo após o resgate: ${balance.toLocaleString('pt-BR') === 'NaN' ? '0': balance.toLocaleString('pt-BR') } pontos`

	return (
		<p>
			<span>{text}</span>
		</p>
	)
}

export default BalanceAfterPurchase
